import type { CSSProperties } from "react";
import { HatcheryIcon } from "@carbon6/c6-frontend-design";
import styles from "./HatcheryLogo.module.css";

const hatcheryLogoSize = 56;

type HatcheryLogoProps = {
  className?: string;
  style?: CSSProperties;
};

// 앱 Hatchery 로고의 원본은 c6 디자인 시스템의 HatcheryIcon(V3 brand mark)이다.
// 크기는 CSS(.logo / 소비처 className)가 정한다. size prop은 fallback 기본값이다.
export function HatcheryLogo({ className, style }: HatcheryLogoProps) {
  return (
    <HatcheryIcon
      size={hatcheryLogoSize}
      className={[styles.logo, className].filter(Boolean).join(" ")}
      style={style}
    />
  );
}
